export const getCategories = () => {
  return `query {
    categoriaPrincipals {
      nombre
    }
  }`;
}

export const getShopCategories = () => {
  return `query {
    categoriaPrincipals {
      categoria {
        nombre
      }
      nombre
    }
  }`;
}
